import React, { useContext, useEffect, useState } from 'react'
import Message from './Message';
import { doc, onSnapshot } from 'firebase/firestore';
import { ChatContext } from '../context/ChatContext';
import { db } from '../firebase';

const Messages = () => {
  const [messages, setMessages] = useState([])
  const { data } = useContext(ChatContext);

  useEffect(() => {
    if (data.chatId) {
      const unsub = onSnapshot(doc(db, "chats", data.chatId), (doc) => {
        doc.exists() && setMessages(doc.data().messages);
      });
      return () => {
        unsub();
      };
    }
  }, [data.chatId]);
  
  return (
    <div className='chat-messages'>
      {messages.length > 0 && (
        <div className="chat-date-divider">
          <span>Today</span>
        </div>
      )}
      
      <div className="chat-messages__list">
        {messages.map((m) => (
          <Message message={m} key={m.id} />
        ))}
      </div>
    </div>
  );
};

export default Messages;